import type { MessagePayload, ClientToHostMessage } from "@rubyplay/effw-connector";

function createInstanceId(): string {
	try {
		if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
			return crypto.randomUUID();
		}
	} catch {
		// Ignore and fall through to the deterministic fallback below.
	}

	const randomPart = Math.random().toString(36).slice(2);
	const timePart = Date.now().toString(36);

	return `ef-${timePart}-${randomPart}`;
}

const INSTANCE_ID = createInstanceId();

let fatalAlreadyReported = false;

export function getEfRuntimeInstanceId(): string {
	return INSTANCE_ID;
}

export function markFatalReported(): void {
	fatalAlreadyReported = true;
}

export function hasFatalBeenReported(): boolean {
	return fatalAlreadyReported;
}

export function serializeUnknownError(error: unknown): { message: string; stack?: string } {
	if (error instanceof Error) {
		return {
			message: error.message || error.name || "Unknown Error",
			stack: error.stack,
		};
	}

	if (typeof error === "string") {
		return { message: error };
	}

	try {
		return { message: JSON.stringify(error) };
	} catch {
		return { message: String(error) };
	}
}

export function buildFatalPayload(
	category: MessagePayload<ClientToHostMessage, "FatalError">["category"],
	error: unknown
): MessagePayload<ClientToHostMessage, "FatalError"> {
	const serialized = serializeUnknownError(error);

	return {
		instanceId: getEfRuntimeInstanceId(),
		category,
		message: serialized.message,
		stack: serialized.stack,
	};
}